import React from "react";
import { useParams } from "react-router-dom";
import { Col, Row } from "antd";

import useMapData from "../../utils/useMapData";

const Payment = React.forwardRef((props, ref) => {
  const { propertyId } = useParams();
  const resultList = useMapData(propertyId);

  return (
    <>
      <Row ref={ref} className="payment_wrapper">
        <div className="payment_image">
          <Row className="payment_overlay">
            <Col lg={24} className="payment">
              <Row>
                <h1>Payment Plan</h1>
              </Row>
              <Row
                style={{ width: "100%" }}
                justify="center"
                id="payment_mobile"
              >
                {resultList?.paymentPlan?.map((item, index) => {
                  return (
                    <Col
                      key={item?.payout}
                      lg={item?.handover ? 4 : 2}
                      className="payment_box"
                    >
                      <p>{item?.amount}%</p>
                      <h3>{item?.payout}</h3>
                    </Col>
                  );
                })}
              </Row>
            </Col>
          </Row>
        </div>
      </Row>
    </>
  );
});

export default Payment;
